<mat-label class="subHeading ">GVW</mat-label>

<div formGroupName="gvw" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="6" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="6" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        gvwForm.controls['from'].hasError('small')
        ||
        gvwForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
